/*
 * CUSTOM 2026-09-09 — Karussell fuer den Block "Passende Produkte (Metafeld)".
 *
 * Der Theme-Block "Ergaenzende Produkte" nutzt <product-complementary>. Dessen connectedCallback
 * greift ueber closest('product-recommendations') auf die Blaetter-Knoepfe zu — ohne diesen
 * Vorfahren wirft es. Und <product-recommendations> selbst laedt beim Sichtbarwerden per fetch
 * nach und blendet sich aus, wenn nichts zurueckkommt; unsere Karten stehen aber schon im HTML.
 * Deshalb ein eigenes Element mit derselben Flickity-Konfiguration wie im Theme.
 */
if (!customElements.get('custom-matching-products')) {
class CustomMatchingProducts extends HTMLElement {
  connectedCallback() {
    this.row = this.querySelector('[data-matching-row]');
    this.wireVariantSelects();

    // Ohne die Klasse steht nur eine Karte da — dann ist nichts zu blaettern.
    if (!this.row || !this.row.classList.contains('flickity')) return;

    if (window.theme && theme.Carousel) {
      this.init();
    } else {
      // theme.js wird mit defer geladen; bei geaenderter Reihenfolge hier nachfassen.
      document.addEventListener('DOMContentLoaded', () => {
        if (window.theme && theme.Carousel) this.init();
      }, { once: true });
    }
  }

  init() {
    if (this.carousel) return;

    this.carousel = new theme.Carousel(this.row, {
      accessibility: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      pageDots: false,
      contain: true,
      cellAlign: 'center',
      rightToLeft: theme.config.rtl,
    }, {
      previous: this.querySelector('[data-prev-button]'),
      next: this.querySelector('[data-next-button]')
    });

    this.carousel.load();
  }

  /* CUSTOM 2026-09-16 — Varianten-Auswahl unter den Karten.
     Die Karte kommt aus 'product-card-horizontal' und kennt keine Variantenwahl: Sie legt
     stumm die erste verfuegbare Variante in den Warenkorb. Beim Wechsel im Dropdown werden
     deshalb hier alle Stellen nachgezogen, die eine Variante tragen — Warenkorb-Formular,
     Kaufen-Knopf, Preis und die Links auf die Produktseite. */
  wireVariantSelects() {
    /* Der Kauf-Knopf ist serverseitig deaktiviert, solange keine Variante gewaehlt ist.
       Das Abfangen per Submit-Listener hat nicht funktioniert: Die Upselling-App haengt sich
       auf Dokument-Ebene ein und laeuft damit vor jedem Listener an dieser Section.
       Deaktivierte Knoepfe feuern gar kein Klick-Ereignis — deshalb liegt fuer die Sprechblase
       eine unsichtbare Flaeche darueber. */
    this.querySelectorAll('[data-matching-card][data-needs-choice]').forEach((card) => {
      const halter = card.querySelector('.horizontal-product__quantity');
      if (!halter || halter.querySelector('.matching-card__guard')) return;
      const guard = document.createElement('span');
      guard.className = 'matching-card__guard';
      guard.setAttribute('aria-hidden', 'true');
      halter.append(guard);
    });

    /* Nur auf Klick, nicht beim Ueberfahren: Wer mit der Maus ueber die Karten faehrt, soll
       nicht staendig Blasen aufpoppen sehen. Nach kurzer Zeit verschwindet sie von selbst.
       Der Zeitgeber haengt am jeweiligen Tooltip, nicht am Element — sonst wuerde bei zwei
       offenen Blasen der spaetere Klick die falsche ausblenden. */
    this.addEventListener('click', (event) => {
      const guard = event.target.closest('.matching-card__guard');
      if (!guard) return;

      const card = guard.closest('[data-matching-card]');
      const tip = card && card.querySelector('[data-matching-tip]');
      if (!tip) return;

      clearTimeout(tip._timer);
      tip.hidden = false;
      tip._timer = setTimeout(() => { tip.hidden = true; }, 3500);

      const select = card.querySelector('[data-matching-variant-select]');
      if (select) select.focus();
    });

    this.addEventListener('change', (event) => {
      const select = event.target.closest('[data-matching-variant-select]');
      if (!select) return;

      const card = select.closest('[data-matching-card]');
      if (!card) return;

      const option = select.selectedOptions[0];
      if (!option) return;

      const variantId = option.value;
      /* Platzhalter gewaehlt: Knopf bleibt verborgen, nichts wird umgeschrieben. */
      if (!variantId) return;

      const verfuegbar = option.dataset.available !== 'false';

      /* Ab jetzt steht eine Variante fest: Knopf freigeben, Klickflaeche und Sprechblase weg. */
      card.removeAttribute('data-needs-choice');
      const tip = card.querySelector('[data-matching-tip]');
      if (tip) {
        clearTimeout(tip._timer);
        tip.hidden = true;
      }
      const guard = card.querySelector('.matching-card__guard');
      if (guard) guard.remove();
      const kaufen = card.querySelector('[data-needs-variant]');
      if (kaufen) {
        kaufen.disabled = false;
        kaufen.removeAttribute('data-needs-variant');
      }

      const input = card.querySelector('input[name="id"]');
      if (input) input.value = variantId;

      const button = card.querySelector('[data-variant-id]');
      if (button) {
        button.dataset.variantId = variantId;
        button.disabled = !verfuegbar;
      }

      /* Nur den regulaeren Preis ersetzen. Streichpreise und Spar-Hinweise bleiben stehen,
         wie sie fuer das Produkt gerendert wurden — sie umzurechnen waere Ratearbeit. */
      const preis = card.querySelector('.price__regular');
      if (preis && option.dataset.price) preis.textContent = option.dataset.price;

      const basis = card.dataset.productUrl || '';
      if (basis) {
        card.querySelectorAll('a[href]').forEach((link) => {
          const href = link.getAttribute('href') || '';
          if (href.split('?')[0] !== basis) return;
          link.setAttribute('href', `${basis}?variant=${variantId}`);
        });
        const quickView = card.querySelector('[data-product-url]');
        if (quickView) quickView.dataset.productUrl = `${basis}?variant=${variantId}`;
      }
    });
  }

  disconnectedCallback() {
    if (this.carousel) {
      this.carousel.unload();
      this.carousel = null;
    }
  }
}

customElements.define('custom-matching-products', CustomMatchingProducts);
}
